import { render } from "./TopStepperComponent.vue?vue&type=template&id=53fbc2b1"
import script from "./TopStepperComponent.vue?vue&type=script&lang=js"
export * from "./TopStepperComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__